<template>
  <b-row :key="remountingKey">
    <!-- TODO Hidden for a while: will be open for next enhance -->
    <b-col class="d-none">
      <b-dropdown
      id="actions-dropdown"
      toggle-tag="div"
      toggle-class="p-0 bg-transparent"
      class="w-auto"
    >
      <template #button-content>
        <McButton
          variant="secondary"
          icon="icon-outline_chevron-down"
          icon-position="right"
          :text="textExpenseType"
        />
      </template>

      <b-dropdown-item
        class="mc-dashboard__order-dropdown"
        v-for="(val, key) in expenseTypeList"
        :key="key"
        @click="handleChangeExpenseType(val)"
        :class="{ 'font-weight-bold': val.id === expenseType }"
      >
        {{ val.text }}
      </b-dropdown-item>
    </b-dropdown>
    </b-col>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-row>
          <b-col cols="12">
            <div class="d-flex mc-expense-priod-skeleton align-items-end">
              <b-skeleton width="30px" height="200px" />
              <b-skeleton class="ms-5" width="30px" height="100px" />
              <b-skeleton class="ms-5" width="30px" height="70px" />
              <b-skeleton class="ms-5" width="30px" height="150px" />
              <b-skeleton class="ms-5" width="30px" height="165px" />
              <b-skeleton class="ms-5" width="30px" height="110px" />
              <b-skeleton class="ms-5" width="30px" height="40px" />
              <b-skeleton class="ms-5" width="30px" height="95px" />
            </div>
          </b-col>
        </b-row>
      </template>
      <b-col cols="12">
        <div class="mc-dashboard__total-expense">
          <div class="expense-chart--bar">
            <BarChart
              :labels="chartData.labels"
              :datasets="chartData.datasets"
              :options="options"
            />
          </div>
        </div>
      </b-col>
    </b-skeleton-wrapper>
  </b-row>
</template>
<script>
import BarChart from '@/components/Chart/Bar'
import McButton from '@/components/McButton'
import { expenseByPeriod } from '@/services/rest-api/lib/expense/expense'
import values from 'lodash/values'
export default {
  components: {
    BarChart,
    McButton
  },
  props: {
    periodType: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      expenseTypeList: [
        { id: '', text: 'Total Pengeluaran' },
        { id: 'FLEET_TASK', text: 'Total Pengeluaran Penugasan', desc: 'Biaya Penugasan' },
        { id: 'VEHICLE', text: 'Total Pengeluaran Kendaraan', desc: 'Biaya Kendaraan' },
        { id: 'OTHER', text: 'Total Pengeluaran Lainya', desc: 'Biaya Lainya' }
      ],
      expenseType: 'FLEET_TASK',
      loading: false,
      datasets: [],
      options: {
        legend: {
          fullWidth: false,
        },
        tooltips: {
          bodyFontSize: 12,
          bodySpacing: 9,
          backgroundColor: 'rgb(52 66 100 / 95%)',
          titleFontSize: 20,
          callbacks: {
            title: () => {
              return ''
            },
            label: (tooltipItem, data) => {
              const label = data.datasets[tooltipItem.datasetIndex].label
              return `  ${ label }`;
            },
            afterBody: function(tooltipItem, data) {
              const item = tooltipItem[0]
              const amount = data.datasets[item.datasetIndex].data[item.index]
              const alldata = data.datasets[item.datasetIndex].data
              const sum = alldata.reduce((partialSum, current) => partialSum + current, 0)
              const currentValue = Math.round((alldata[item.index] / sum) * 100)

              return `${ currentValue }%\nRp ${ amount.toLocaleString() }`;
            }
          }
        },
        scales: {
          xAxes: [{
              stacked: true,
              gridLines: {
                  display: true,
                  drawOnChartArea: false,
                  color: '#EBECEF',
                  lineWidth: 1.5
              }
          }],
          yAxes: [{
              stacked: true,
              gridLines: {
                  display: true,
                  drawOnChartArea: false,
                  color: '#EBECEF',
                  lineWidth: 1.5
              },
              ticks: {
                callback: (label) => {
                  if (label === 0 || label/1000 < 1) return label
                  if (label/1000000 >= 1) return label/1000000 + this.$t('dashboard.object.millionSuffix')
                  if (label/1000 >= 1) return label/1000 + this.$t('dashboard.object.thousandSuffix')
                }
              },
              afterDataLimits(scale) {
                scale.max += scale.max / 4
              }
          }]
        }
      },
      // This key will help remounting chart component if users change their language
      remountingKey: 1,
    }
  },
  computed: {
    textExpenseType() {
      return this.expenseTypeList.find(v => v.id === this.expenseType)?.text
    },
    chartData() {
      const labels = []
      let datasets = {}
      const len = this.datasets.length
      const types = this.expenseTypeList.filter(v => v.id !== '')
      types.forEach(val => {
        datasets[val.id] = {
          label: this.getLabel(val.id),
          data: [],
          backgroundColor: [],
          barPercentage: (parseFloat((1 / len).toFixed(2))) + (len > 7 ? 0.5 : 0.2)
        }
      })
      this.datasets.forEach(val => {
        labels.push(val.label)
        const groupTemp = ['FLEET_TASK', 'VEHICLE', 'OTHER']
        const subdata = this.expenseType ? val.data.filter(v => v.group === this.expenseType) : val.data

        if (!subdata.length) {
          types.forEach(val => {
            datasets[val.id].data.push(0)
            datasets[val.id].backgroundColor.push('')
          })
        } else {
          subdata.forEach((value) => {
            datasets[value.group].backgroundColor.push(value.color)
            datasets[value.group].data.push(value.amount)

            // Remove groupTemp by group [FLEET_TASK/VEHICLE/OTHER]
            groupTemp.splice(groupTemp.indexOf(value.group), 1)
          })

          // Looping remaining groupTemp
          groupTemp.forEach(val => {
            datasets[val].data.push(0)
            datasets[val].backgroundColor.push('')
          })
        }
      })

      // Filter data that has a total more than 0
      datasets = values(datasets).filter(v => v.data.reduce((a, b) => a + b, 0) !== 0)

      // Set color to backgroundColor property to drawing the legend
      datasets.forEach((val, key) => {
        const color = val.backgroundColor.find(v => v !== '')
        datasets[key].backgroundColor[0] = color
      })

      return {
        labels,
        datasets
      }
    }
  },
  watch: {
    periodType() {
      this.getData()
    },
    '$i18n.locale': function () {
      this.remountingKey += 1
    }
  },
  created() {
    this.getData()
  },
  methods: {
    handleChangeExpenseType(item) {
      this.expenseType = item.id
      this.getData()
    },
    async getData() {
      this.loading = true
      const params = {
        reference_type: this.expenseType,
        period: this.periodType
      }
      const res = await expenseByPeriod(params)
      if (res.errors) {
        this.$mcToast.error(res.message)
        return
      }
      this.datasets = res.details_amount
      this.loading = false
    },
    getLabel(labelId) {
      switch (labelId) {
        case "FLEET_TASK":
          return this.$t('dashboard.text.costLabelFleetTask')
        default:
          return ""
      }
    }
  },
}
</script>
<style lang="scss">
.expense-chart--bar {
  canvas {
    height: 300px !important;
  }
}
.mc-expense-priod-skeleton {
  margin-left: 95px;
  margin-top: 80px;
  padding-bottom: 16px;
}
</style>